/**
 * Expanded type definitions for new colors
 * @see https://material-ui.com/customization/palette/
 */
declare module '@mui/material/styles/createPalette' {
  interface Palette {
    ink: Palette['primary'];
    sky: Palette['primary'];
    ghost: Palette['primary'];
  }
  interface PaletteOptions {
    ink: PaletteOptions['primary'];
    sky: PaletteOptions['primary'];
    ghost: PaletteOptions['primary'];
  }
}

declare module '@mui/material/SvgIcon' {
  interface SvgIconPropsColorOverrides {
    ink: true;
    sky: true;
    ghost: true;
  }
}

const palette = {
  mode: 'light' as const,
  primary: {
    main: '#00B74F',
    dark: '#008439',
    light: '#F3FAF3',
    contrastText: '#FFFFFF',
  },
  secondary: {
    main: '#12312B',
    dark: '#182926', // TBD?: #041613
    light: '#D9D9D9', // TBD?: remove; this duplicates ink color
    contrastText: '#FFFFFF',
  },
  success: {
    main: '#44D62C', // TBD?: #00B74F
    // dark: will be calculated from palette.success.main,
    // light: will be calculated from palette.success.main,
    contrastText: '#FFFFFF',
  },
  warning: {
    main: '#FF9D00',
    // dark: will be calculated from palette.warning.main,
    light: '#FF9D24',
    contrastText: '#FFFFFF',
  },
  error: {
    main: '#E53935', // what happened to #E93C3C? // TBD: #E54B48
    dark: '#E54B48', // TBD: switch to avoid conflict with main hue
    light: '#FFDEDD',
    contrastText: '#FFFFFF',
  },
  info: {
    main: '#0095E5',
    dark: '#006AA3',
    light: '#ECF5FB', // TBD?: #F3F5F7 (no sky?)
    contrastText: '#FFFFFF',
  },
  ink: {
    main: '#333333',
    dark: '#182926', // replaces #041613 at 92% opacity?
    light: '#D9D9D9',
  },
  sky: {
    main: '#F3F5F7',
    contrastText: '#333333',
  },
  ghost: {
    main: '#D4D4D4', // TBD?: get rid of this?
    dark: '#9C9C9C',
    light: '#E5E5E5', // Seemin calls this "main"
  },
  text: {
    primary: '#333333',
    secondary: '#808080',
    disabled: '#33333380',
  },
  background: {
    default: '#F5F5F5',
    paper: 'white',
  },
  action: {
    disabled: undefined,
  },
};

export default palette;
